module.exports = __webpack_public_path__ + "img/photo-04.7ed20cf2.jpg";